import { ComponentProps } from 'react';

import { Menu } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Box } from '@mui/system';

import { Logo } from 'components/images';

type MenuModulesButton = {
    onClick: ComponentProps<typeof Button>['onClick'];
};

/**
 * Botão responsável por abrir o menu de módulos.
 */
export function MenuModulesButton({ onClick }: MenuModulesButton) {
    return (
        <Button
            onClick={onClick}
            sx={{
                'mr': 'auto',
                'px': 1.5,
                'py': 0.5,
                'gap': 1.5,
                'height': 40,
                'border': 1,
                'borderRadius': 1.5,
                'color': 'common.white',
                'borderColor': (theme) => theme.lighten(theme.palette.secondary.main, 0.2),
                'backgroundColor': (theme) => theme.lighten(theme.palette.secondary.main, 0.075),
                '&:hover': {
                    borderColor: (theme) => theme.lighten(theme.palette.secondary.main, 0.3),
                    backgroundColor: (theme) => theme.lighten(theme.palette.secondary.main, 0.15),
                },
            }}
        >
            <Menu />

            <Logo />
        </Button>
    );
}
